var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8.8 5c0-.4-.4-.7-.8-.7-.5 0-1 .3-1 .8 0 .6.5 1 1 1 .4 0 .8-.4.8-1zm-1.6 6c0 .4.4.8.8.8s.8-.4.8-.8V8c0-.4-.4-.8-.8-.8s-.8.4-.8.8v3zM14 8c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6 6 2.7 6 6z"}));
}

Info.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Info;

Info.default = Info;
